import React from 'react';
import './Error404View.less';
import { Item, Row, Column } from 'react-plan';

type Props = {

}

class Error404View extends React.Component {

  description: 'The view where users can edit their profile.'

  props: Props

  constructor(props: Props) {
    super(props);
  }

  /* Component Custom Methods */
  /* End Component Custom Methods */

  /* React Component LifeCycle Methods */
  //componentWillMount() {}
  //componentDidMount() {}
  //componentWillReceiveProps(nextProps) {}
  //shouldComponentUpdate(nextProps, nextState) {}
  //componentWillUpdate(nextProps, nextState) {}
  //componentDidUpdate(prevProps, prevState) {}
  //componentWillUnmount() {}
  render() {
    return (
      <div className="error404">
        <Row justify="center" align="center">
          <Item className="txt-404">
            <div className="lost-txt">
              <h1 className="txt-center">Error 404</h1>
              <h3 className="txt-center">Lost in space</h3>
            </div>
            <img
              alt="galaxy"
              className="rotating galaxy"
              src={ require('../../../img-layout/lost-space-ship.png') } />
          </Item>
        </Row>
        <Item className="bg-404">
        </Item>
      </div>
    );
  }
  /* End React Component LifeCycle Methods */
}

export default Error404View;

//Unit test entry point
export const Error404ViewTest = Error404View;


/** WEBPACK FOOTER **
 ** ./src/js/views/Error404View/Error404View.jsx
 **/